import { render, staticRenderFns } from "./TagItem.vue?vue&type=template&id=71d05896&scoped=true&"
import script from "./TagItem.vue?vue&type=script&lang=js&"
export * from "./TagItem.vue?vue&type=script&lang=js&"
import style0 from "./TagItem.vue?vue&type=style&index=0&id=71d05896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d05896",
  null
  
)

export default component.exports